module.exports = __webpack_public_path__ + "media/images/talent/case3-icon02-7be05572a256c7b8d6c2ee06e9326dea.png";